/** The `mls_coverage` kind's options (backend `viewer/report_kinds.py`, MLS_COVERAGE_OPTIONS) as the page reads them. */
export type ScanSection = 'map' | 'summary' | 'areas' | 'plots';
export const SCAN_SECTIONS: ScanSection[] = ['summary', 'map', 'areas', 'plots'];

export interface ScanCoverageConfig {
  sections: Record<ScanSection, { enabled: boolean }>;
}

const isObject = (v: unknown): v is Record<string, unknown> => v !== null && typeof v === 'object' && !Array.isArray(v);

/** The stored options over the defaults: a report saved before a section existed still shows it. */
export function scanCoverageConfig(raw: unknown): ScanCoverageConfig {
  const stored = isObject(raw) && isObject(raw.sections) ? raw.sections : {};
  const sections = Object.fromEntries(
    SCAN_SECTIONS.map((s) => {
      const v = stored[s];
      return [s, { enabled: isObject(v) && typeof v.enabled === 'boolean' ? v.enabled : true }];
    }),
  ) as ScanCoverageConfig['sections'];
  return { sections };
}
